// @flow

// Utils
import { hasRole } from 'fc-model-users'

// Role
import { HEFTY_ROLE } from '../constants'

// Exports
export default hasRole(HEFTY_ROLE)
